<template>
  <div class="map-box">
    <map-types @on-click="onTypeChange" :map="mapbox" />
    <div id="map"></div>
    <sz-modal v-model="show" width="40vw" height="70vh" :title="modalTitle">
      <DMATable :data="dmaData" />
    </sz-modal>
    <sz-modal v-model="show2" width="40vw" height="70vh" title="昨日用水量">
      <DMATable2 :index="page" :dma="dma" />
    </sz-modal>
  </div>
</template>

<script>
import mapboxgl from "mapbox-gl";
import szModal from "@/components/szModal.vue";
import MapLayer from "@/utils/MapLayer";
import Vue from "vue";
import MarkerPopup from "@/views/home/modules/MarkerPopup.vue";
import MapMarker from "@/views/home/modules/MapMarker.vue";
import coordtransform from "coordtransform";
import * as turf from "@turf/turf";
import DMATable from "@/views/home/modules/DMATable.vue";
import DMATable2 from "@/views/home/modules/DMATable2.vue";
import MapTypes from "@/components/map/MapTypes.vue";
import proj4 from "proj4";
import GisPopup from "@/views/home/modules/GisPopup.vue";
import { Message } from "element-ui";
import Pipes from "@/components/map/dma_pipes.json";

mapboxgl.accessToken =
  "pk.eyJ1IjoiaGFvMzMwNCIsImEiOiJkTUNxRXFBIn0.M626Jd01QqntO8oMiBHLPw";
export default {
  components: { DMATable2, szModal, DMATable, MapTypes },
  data() {
    return {
      canQueryArcGIS:true,
      show: false,
      show2: false,
      page: null,
      modalTitle: "最新抄读",
      mapbox: null,
      dmaData: {},
      markers: {},
      dma: null,
    };
  },
  methods: {
    render() {
      const key = "04f65c2ff30922b1f615f42c80db4ebe";
      const getImgUrls = () => {
        return [0, 1, 2, 3].map((s) => {
          return `https://t${s}.tianditu.gov.cn/img_w/wmts?SERVICE=WMTS&REQUEST=GetTile&VERSION=1.0.0&LAYER=img&STYLE=default&TILEMATRIXSET=w&FORMAT=tiles&TILECOL={x}&TILEROW={y}&TILEMATRIX={z}&tk=${key}`;
        });
      };
      const vectorUrl =
        "https://t0.tianditu.gov.cn/vec_w/wmts?SERVICE=WMTS&REQUEST=GetTile&VERSION=1.0.0&LAYER=vec&STYLE=default&TILEMATRIXSET=w&TILEMATRIX={z}&TILEROW={y}&TILECOL={x}&FORMAT=tiles&tk=" +
        key;
      const map = (this.mapbox = new mapboxgl.Map({
        container: "map",
        antialias: true,
        maxZoom: 30,
        maxTileCacheSize: 1000,
        style: {
          glyphs: "mapbox://fonts/mapbox/{fontstack}/{range}.pbf",
          version: 8,
          sources: {
            img: {
              type: "raster",
              tiles: getImgUrls(),
              tileSize: 256,
              maxzoom: 18,
            },
            vector: {
              type: "raster",
              tiles: [vectorUrl],
              tileSize: 256,
              maxzoom: 18,
            },
          },
          layers: [
            {
              id: "imgLayer",
              source: "img",
              type: "raster",
              layout: {
                visibility: "visible",
              },
            },
            {
              id: "vectorLayer",
              source: "vector",
              type: "raster",
              layout: {
                visibility: "none",
              },
            },
          ],
        },
        zoom: 14,
        center: [114.31, 30.36],
        pitch: 0,
        projection: "globe",
      }));

      this.$emit("init", map);

      const cvawUrl =
        "https://t3.tianditu.gov.cn/cia_w/wmts?" +
        "SERVICE=WMTS&REQUEST=GetTile&VERSION=1.0.0&LAYER=cia&STYLE=default&TILEMATRIXSET=w&FORMAT=tiles&" +
        "TILECOL={x}&TILEROW={y}&TILEMATRIX={z}&tk=" +
        key;
      map.on("load", () => {
        // this.addTitleLayer(map, getImgUrls(), "vecw", "vecw");
        // this.addTitleLayer(map, [cvawUrl], "cvawUrl", "cvawUrl");
        // this.addPipe(map);
        this.addSky(map);
        this.addPipe(map);
        // this.addBuilding(map);
        // this.addDem(map);
        map.addSource("dma_pipes", {
          type: "geojson",
          data: {
            type: "FeatureCollection",
            features: Pipes.map((i) => {
              return {
                type: "Feature",
                properties: {},
                geometry: i,
              };
            }),
          },
        });
        map.addLayer({
          id: "dma_pipes",
          type: "line",
          source: "dma_pipes",
          layout: {
            "line-join": "round",
            "line-cap": "round",
          },
          paint: {
            "line-color": "#0025fb",
            "line-width": 8,
          },
        });
      });
    },
    addTitleLayer(map, url, sourceId, layerId, tileSize = 256) {
      map.addSource(sourceId, {
        type: "raster",
        tiles: url,
        tileSize: tileSize,
        maxzoom: 30,
      });

      map.addLayer({
        id: layerId,
        type: "raster",
        source: sourceId,
      });
    },
    addPipe(map) {
      const pipeUrl =
        process.env.VUE_APP_SERVER +
        "/rhenium/gis-pipe-wgs84?service=WMS&version=1.1.0&request=GetMap&layers=show%3Aall&bbox={bbox-epsg-3857}&width=512&height=512&srs=EPSG%3A3857&format=image%2Fpng&transparent=true&f=image";
      this.addTitleLayer(map, [pipeUrl], "pipeUrl", "pipeUrl", 512);
      
      // const pipeUrl =
      //   "https://water.shreli.com/geoserver/jxsw/wms?service=WMS&version=1.1.0&request=GetMap&layers=jxsw%3At_line&bbox={bbox-epsg-3857}&width=256&height=256&srs=EPSG%3A3857&format=image%2Fpng&transparent=true";
      // const pipeUrl2 =
      //   "https://water.shreli.com/geoserver/jxsw/wms?service=WMS&version=1.1.0&request=GetMap&layers=jxsw%3Ai_line&bbox={bbox-epsg-3857}&width=256&height=256&srs=EPSG%3A3857&format=image%2Fpng&transparent=true";
      // this.addTitleLayer(map, [pipeUrl], "pipeUrl", "pipeUrl");
      // this.addTitleLayer(map, [pipeUrl2], "pipeUrl2", "pipeUrl2");
      map.on("click", (e) => {
        if(this.canQueryArcGIS){
          let features = map.queryRenderedFeatures(e.point);
          if (e.originalEvent.target.tagName === "CANVAS" && !features.length) {
            const latLng = e.lngLat; // 获取点击点的经纬度
            this.queryArcGIS(this.lonLatToMercator(latLng), map); // 调用查询函数
          }
        }
      
      });
    },
    addDem(map) {
      map.addSource("mapbox-dem", {
        type: "raster-dem",
        url: "mapbox://mapbox.mapbox-terrain-dem-v1",
        tileSize: 512,
        maxzoom: 14,
      });
      map.setTerrain({ source: "mapbox-dem", exaggeration: 1.5 });
    },
    addSky(map) {
      map.addLayer({
        id: "sky",
        type: "sky",
        paint: {
          // 渐进天空
          "sky-type": "gradient",
          // 中间白，向外逐渐扩散
          // 模拟了地平线以下太阳的外观
          "sky-gradient": [
            "interpolate",
            ["linear"],
            ["sky-radial-progress"],
            0.8,
            "rgb(34,124,217)",
            1,
            "rgba(135, 206, 235, 0.2)",
          ],
          "sky-gradient-center": [0, 0],
          "sky-gradient-radius": 90,
          "sky-opacity": [
            "interpolate",
            ["exponential", 0.1],
            ["zoom"],
            5,
            0,
            22,
            1,
          ],
        },
      });
    },
    addBuilding(map) {
      map.addLayer({
        id: "3d-buildings",
        source: "composite",
        "source-layer": "building",
        filter: ["==", "extrude", "true"],
        type: "fill-extrusion",
        minzoom: 15,
        paint: {
          "fill-extrusion-color": "#aaa",

          // use an 'interpolate' expression to add a smooth transition effect to the
          // buildings as the user zooms in
          "fill-extrusion-height": [
            "interpolate",
            ["linear"],
            ["zoom"],
            15,
            0,
            15.05,
            ["get", "height"],
          ],
          "fill-extrusion-base": [
            "interpolate",
            ["linear"],
            ["zoom"],
            15,
            0,
            15.05,
            ["get", "min_height"],
          ],
          "fill-extrusion-opacity": 0.6,
        },
      });
    },
    clearLayers() {
      if (this.mapbox) {
        const markers = [...this.mapbox._markers];
        markers.forEach((marker) => {
          marker.remove();
        });
      }
    },
    onChangeMn(value){
      const item = {
        "id": "cs01",
        "dma": null,
        "station": "65efd0986e20a90001a8f292",
        "mtype": "D03",
        "roles": "1",
        "o_station": {
          "cmmid": null,
          "id": "cs01",
          "code": "2201000116",
          "name": "春申路DN300",
          "type": "monitor",
          "area": "6229a8af133ced00013a3732",
          "addr": null,
          "position": "114.377101,30.333535",
          "position_type": "gps",
          "time": 1764248640,
          "online": 1,
          "events": null,
          "devices": [
            {
              "code": "2201000116",
              "cmmid": "493040058"
            }
          ],
          "o_area": {
            "name": "五里界",
            "area": null
          },
          "sensors": [
            {
              "id": "623567ab61a1f9000192e0ad",
              "channel": "flow",
              "unit": "A1",
              "name": "瞬时流量",
              "required": null,
              "o_unit": {
                "unit": "m³/h",
                "name": "瞬时流量"
              },
              "o_realtime": {
                "id": "623567ab61a1f9000192e0ad",
                "time": 1764248640,
                "value": 317.500
              }
            },

            {
              "id": "623567ab61a1f9000192e0b1",
              "channel": "pressure",
              "unit": "A2",
              "name": "瞬时压力",
              "required": null,
              "o_unit": {
                "unit": "MPa",
                "name": "瞬时压力"
              },
              alarm:!value,
              "o_realtime": {
                "id": "623567ab61a1f9000192e0b1",
                "time": 1764248640,
                "value": value?0.368:0.1
              }
            },

          ]
        }
      }

      if(value){
        this.markers[item.id].marker.remove()
      }else{
        let position = item.o_station.position.split(",");
        this.markers[item.id] = { marker: null, popup: null };
        this.markers[item.id].marker = new mapboxgl.Marker({
          element: new Vue({
            el: document.createElement("div"),
            render: () => {
              return <MapMarker type={item.mtype}></MapMarker>;
            },
          }).$el,
          anchor: "bottom",
        });
        if (item.o_station.position_type !== "gps") {
          this.markers[item.id].marker.setLngLat(
              coordtransform.gcj02towgs84(position[0], position[1])
          );
        } else {
          this.markers[item.id].marker.setLngLat([position[0], position[1]]);
        }
        this.markers[item.id].marker.addTo(this.mapbox);

        let popupHTML = new Vue({
          el: document.createElement("div"),
          render: () => {
            return (
                <MarkerPopup
                    type={item.mtype}
                    data={item.o_station}
                ></MarkerPopup>
            );
          },
        }).$el;

        this.markers[item.id].popup = new mapboxgl.Popup({
          offset: [0, -60],
          className: "D03",
          maxWidth: "311px",
        }).setHTML(popupHTML.innerHTML);
        this.markers[item.id].marker.setPopup(this.markers[item.id].popup);
        this.markers[item.id].marker._element.style.filter = 'drop-shadow(red 0px 0px 9px)';
      }
    },
    onMarkerPosition(id){

      const marker = this.markers[id].marker;
      marker.togglePopup();
      this.mapbox.flyTo({
        center: [marker._lngLat.lng, marker._lngLat.lat],
        zoom: 16,
        speed: 1.2, // 速度，默认1.2
        curve: 1.42, // 曲线度，默认1.42
        easing: (t) => t, // 缓动函数
        essential: true // 此动画为关键动画，用户操作不能中断
      });

    },
    addMarkers(data) {
      const map = this.mapbox;
      data.forEach((item) => {
        if (!item.o_station.position) return;
        let position = item.o_station.position.split(",");
        let isToggle = false;
        const setPopup = () => {
          let popupHTML = new Vue({
            el: document.createElement("div"),
            render: () => {
              return (
                <MarkerPopup
                  type={item.mtype}
                  data={item.o_station}
                ></MarkerPopup>
              );
            },
          }).$el;
          this.markers[item.id].popup = new mapboxgl.Popup({
            offset: [0, -60],
            className: item.mtype,
            maxWidth: "311px",
          }).setHTML(popupHTML.innerHTML);
          this.markers[item.id].marker.setPopup(this.markers[item.id].popup);
        };
        if (this.markers[item.id]?.marker) {
          isToggle = this.markers[item.id]?.marker.getPopup().isOpen();
          if (
            ["D01", "D03", "D04", "factory", "dma", "pump"].includes(item.mtype)
          ) {
            setPopup();
          }
        } else {
          this.markers[item.id] = { marker: null, popup: null };
          this.markers[item.id].marker = new mapboxgl.Marker({
            element: new Vue({
              el: document.createElement("div"),
              render: () => {
                return <MapMarker type={item.mtype}></MapMarker>;
              },
            }).$el,
            anchor: "bottom",
          });
          if (
            ["D01", "D03", "D04", "factory", "dma", "pump"].includes(item.mtype)
          ) {
            setPopup();
          }
          if (item.o_station.position_type !== "gps") {
            this.markers[item.id].marker.setLngLat(
              coordtransform.gcj02towgs84(position[0], position[1])
            );
          } else {
            this.markers[item.id].marker.setLngLat([position[0], position[1]]);
          }
          this.markers[item.id].marker.addTo(map);
        }
        if (isToggle) {
          this.markers[item.id].marker.togglePopup();
        }
      });
    },
    addDMAMarker(data) {
      const map = this.mapbox;
      const layer = new MapLayer(map);
      data.forEach((item) => {
        if (item.o_station.position) {
          let position = item.o_station.position.split(",");
          const marker = new mapboxgl.Marker({
            element: new Vue({
              el: document.createElement("div"),
              render: () => {
                return (
                  <MapMarker
                    type="dma"
                    detail={item}
                    onModal={this.onDMAClick}
                  ></MapMarker>
                );
              },
            }).$el,
            anchor: "bottom",
          });
          marker.setLngLat(
            coordtransform.gcj02towgs84(position[0], position[1])
          );
          layer.add(marker);
        }
      });
    },
    addPipeMarker(data) {
      const map = this.mapbox;
      if (map.getSource("places")) {
        map.getSource("places").setData(data);
      } else {
        map.addSource("places", {
          type: "geojson",
          data: data,
        });
        map.addLayer({
          id: "places",
          type: "circle",
          source: "places",
          paint: {
            "circle-color": "#4264fb",
            "circle-radius": 10,
            "circle-stroke-width": 2,
            "circle-stroke-color": "#ffffff",
          },
        });
        map.on("mouseenter", "places", () => {
          map.getCanvas().style.cursor = "pointer";
        });
        map.on("mouseleave", "places", () => {
          map.getCanvas().style.cursor = "";
        });
        map.on("click", "places", (e) => {
          this.page = e.features[0].properties.index;
          this.dma = e.features[0].properties.dma;
          this.show2 = true;
        });
      }
    },
    addPolygon(data, init = true) {
      const map = this.mapbox;
      const source = {
        type: "FeatureCollection",
        features: [],
      };
      const colors = [
        "#ffffcc",
        "#a1dab4",
        "#41b6c4",
        "#2c7fb8",
        "#253494",
        "#fed976",
        "#feb24c",
        "#fd8d3c",
        "#f03b20",
        "#bd0026",
        "#B35EFF",
      ];
      const fillColor = ["match", ["get", "index"]];
      data.forEach((item, index) => {
        fillColor.push(...["layer" + index, colors[index]]);
        let start = item.area.split(";")[0];
        let polygon = turf.polygon(
          [
            [
              ...item.area
                .split(";")
                .map((i) =>
                  coordtransform.gcj02towgs84(i.split(",")[0], i.split(",")[1])
                ),
              coordtransform.gcj02towgs84(
                start.split(",")[0],
                start.split(",")[1]
              ),
            ],
          ],
          {
            name: item.o_station.name,
            index: "layer" + index,
            value: item.l2.o_day ? Math.trunc(item.l2.o_day.acc) : "-",
          }
        );
        source.features.push(polygon);
      });
      map.addSource("maine", {
        type: "geojson",
        data: source,
      });
      map.addLayer({
        id: "maine",
        type: "fill",
        source: "maine",
        layout: {},
        paint: {
          "fill-color": [
            "match",
            ["get", "index"],
            "layer0",
            "#ffffcc",
            "layer1",
            "#a1dab4",
            "layer2",
            "#41b6c4",
            "layer3",
            "#2c7fb8",
            "layer4",
            "#253494",
            "layer5",
            "#fed976",
            "layer6",
            "#feb24c",
            "layer7",
            "#fd8d3c",
            "layer8",
            "#f03b20",
            "layer9",
            "#bd0026",
            "layer10",
            "#B35EFF",
            "#ccc",
          ],
          "fill-opacity": 0.5,
        },
      });
      map.addLayer({
        id: "outline",
        type: "line",
        source: "maine",
        layout: {},
        paint: {
          "line-color": "#fff",
          "line-width": 3,
          "line-dasharray": [0, 4, 3],
        },
      });
      if (init) {
        this.onPosition(source);
      }
    },
    onPosition(geometry) {
      const map = this.mapbox;
      const bbox = turf.bbox(geometry);
      if (bbox && geometry.features.length > 0) {
        map.fitBounds(bbox, {
          maxZoom: 11,
        });
      }
    },
    getRandom() {
      return (Math.random() - 0.5) / 10;
    },
    fit(map, layer) {
      map.fitBounds(layer.getBounds(), {
        padding: {
          top: 250,
          bottom: 250,
          left: 500,
          right: 500,
        },
        offset: [0, 50],
        pitch: 60,
      });
    },
    clear() {
      const map = this.mapbox;
      if (!map) return;
      if (map.getSource("places")) {
        map.removeLayer("places");
        map.removeSource("places");
      }
      if (map.getLayer("maine")) {
        map.removeLayer("maine");
        map.removeLayer("outline");
      }
      if (map.getSource("maine")) {
        map.removeSource("maine");
      }
      if (map.getSource("gisLine")) {
        map.removeLayer("gisLine");
        map.removeSource("gisLine");
      }
      if (map.getSource("dma")) {
        map.removeLayer("dma_area");
        map.removeLayer("dma_border");
        map.removeSource("dma");
      }
      if (map.getSource("dma_pipes")) {
        map.removeLayer("dma_pipes");
        map.removeSource("dma_pipes");
      }
      if (this.gisPoint) {
        this.gisPoint.remove();
      }
      for (let i in this.markers) {
        const item = this.markers[i];
        if (item.marker) {
          item.marker.remove();
          item.marker = null;
        }
        if (item.popup) {
          item.popup.remove();
          item.popup = null;
        }
      }
    },
    setCenter(options) {
      this.mapbox.flyTo(options);
    },
    lonLatToMercator({ lng, lat }) {
      const x = (lng * 20037508.34) / 180;
      let y =
        Math.log(Math.tan(((90 + lat) * Math.PI) / 360)) / (Math.PI / 180);
      y = (y * 20037508.34) / 180;
      return { x: x, y: y };
    },
    pointsToLonLat(geometry) {
      const sourceProjection =
        "+proj=tmerc +lat_0=0 +lon_0=114 +k=1 +x_0=500000 +y_0=0 +ellps=GRS80 +units=m +no_defs";
      const targetProjection = "EPSG:4326";
      if (geometry.paths) {
        return geometry.paths.map((path) =>
          path.map((point) => {
            const [x, y] = point;
            return proj4(sourceProjection, targetProjection, [x, y]);
          })
        );
      } else {
        const { x, y } = geometry;
        return proj4(sourceProjection, targetProjection, [x, y]);
      }
    },
    onDMAClick(data) {
      this.show = true;
      this.dmaData = data;
      this.modalTitle = (data.o_station.name || "") + "最新抄读";
    },
    onTypeChange(type) {
      const map = this.mapbox;
      map.setLayoutProperty(
        "imgLayer",
        "visibility",
        type === "img" ? "visible" : "none"
      );
      map.setLayoutProperty(
        "vectorLayer",
        "visibility",
        type === "vector" ? "visible" : "none"
      );
    },
    async addQueryItem(item, map) {
      let popupHTML = new Vue({
        el: document.createElement("div"),
        render: () => {
          return <GisPopup item={item} onDetail={this.onDetail}></GisPopup>;
        },
      }).$el;
      const popup = new mapboxgl.Popup({
        className: "D04",
        maxWidth: "none",
        closeOnClick: false,
        anchor: "bottom",
      }).setHTML(popupHTML.outerHTML);
      if (!this.gisPoint) {
        this.gisPoint = new mapboxgl.Marker({}).setLngLat([0, 0]).addTo(map);
      }
      if (item.geometryType === "esriGeometryPoint") {
        if (map.getSource("gisLine")) {
          map.removeLayer("gisLine");
          map.removeSource("gisLine");
        }
        const latLng = this.pointsToLonLat(item.geometry);
        map.panTo(latLng);
        this.gisPoint.setPopup(popup).setLngLat(latLng);
        this.gisPoint.togglePopup();
      } else {
        const latLng = await fetch("/rhenium/gis-path-wgs84", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ points: item.geometry.paths }),
        })
          .then((response) => response.json())
          .then(({ points }) => points);
        let center = turf.getCoord(turf.center(turf.lineString(latLng.flat())));
        map.panTo(center);
        this.gisPoint.setPopup(popup).setLngLat(center);
        this.gisPoint.togglePopup();
        if (map.getSource("gisLine")) {
          map.getSource("gisLine").setData(turf.lineString(latLng.flat()));
        } else {
          map.addSource("gisLine", {
            type: "geojson",
            data: turf.lineString(latLng.flat()),
          });
          map.addLayer({
            id: "gisLine",
            type: "line",
            source: "gisLine",
            layout: {
              "line-join": "round",
              "line-cap": "round",
            },
            paint: {
              "line-color": "#33CAFF",
              "line-width": 8,
            },
          });
        }
      }
      popup.on("close", () => {
        if (popupHTML) {
          popupHTML.__vue__.$destroy();
          popupHTML = null;
        }
      });
      popup.on("open", () => {
        popupHTML = new Vue({
          el: document.createElement("div"),
          render: () => {
            return <GisPopup item={item} onDetail={this.onDetail}></GisPopup>;
          },
        }).$el;
      });
    },
    onDetail() {
      this.show = true;
    },
    queryArcGIS(latLng, map) {
      const url = "/rhenium/gis-pipe-query-wgs84";
      const bounds = map.getBounds();
      const ne = this.lonLatToMercator(bounds._ne);
      const sw = this.lonLatToMercator(bounds._sw);
      const params = {
        f: "json", // 返回格式
        geometryType: "esriGeometryPoint",
        tolerance: 10,
        geometry: JSON.stringify({
          x: latLng.x,
          y: latLng.y,
        }),
        mapExtent: `${sw.x},${sw.y},${ne.x},${ne.y}`,
        imageDisplay: "719,436,96",
        outFields: "*", // 返回所有字段
        returnGeometry: true, // 是否返回几何图形
      };
      // 使用 fetch 或 XMLHttpRequest 发起请求
      const message = Message("正在查询，请稍候...");
      fetch(url + "?" + new URLSearchParams(params))
        .then((response) => response.json())
        .then(({ results }) => {
          if (results.length > 0) {
            // 处理查询结果
            message.close();
            Message.success("查询成功");
            const feature = results[0];
            this.addQueryItem(feature, map);

            // 可以将查询结果绘制到地图上
          } else {
            message.close();
            Message({
              message: "没有找到匹配的要素",
              type: "error",
            });
            if (map.getSource("gisLine")) {
              map.removeLayer("gisLine");
              map.removeSource("gisLine");
            }
            if (this.gisPoint) {
              this.gisPoint.remove();
              this.gisPoint = null;
            }
          }
        })
        .catch((error) => console.error("查询失败:", error));
    },
  },
  mounted() {
    this.render();
  },
  beforeDestroy() {
    const map = this.mapbox;
    if (map.getLayer("pipeUrl")) {
      map.removeLayer("pipeUrl");
      map.removeSource("pipeUrl");
    }
    if (map.getSource("pipeUrl2")) {
      map.removeLayer("pipeUrl2");
      map.removeSource("pipeUrl2");
    }
    this.clear();
    this.clearLayers();
    map.remove();
    this.mapbox = null;
  },
};
</script>

<style lang="less" scoped>
.map-box {
  width: 100%;
  height: 100%;
}

#map {
  height: 100%;

  ::v-deep .D04 {
    .mapboxgl-popup {
      &-content {
        width: auto;
        height: auto;
        min-width: 231px;
        min-height: 202px;
        background: url("@/views/home/images/popup-bg2.png") no-repeat center;
        background-size: 100% 100%;
      }
    }
  }

  ::v-deep .dma {
    .mapboxgl-popup {
      &-content {
        width: auto;
        height: auto;
        min-width: 231px;
        min-height: 182px;
        background: url("@/views/home/images/popup-bg2.png") no-repeat center;
        background-size: 100% 100%;
        padding-bottom: 30px;
      }
    }
  }

  ::v-deep .flowmeter {
    .mapboxgl-popup {
      &-content {
        width: fit-content;
        min-width: 200px;
        height: 100px;
        background: url("@/views/home/images/popup-bg1.png") no-repeat center;
        background-size: 100% 100%;
      }
    }
  }

  ::v-deep .mapboxgl-popup {
    &-content {
      width: 231px;
      height: 182px;
      padding: 0 15px;
      box-sizing: border-box;
      background: url("@/views/home/images/popup-bg1.png") no-repeat center;
      background-size: 100% 100%;
      display: flex;
      flex-direction: column;
    }

    &-tip {
      display: none;
    }

    &-close-button {
      top: 10px;
      right: 10px;
      width: 12px;
      height: 12px;
      color: #fff;
      line-height: 12px;
      text-align: center;
      cursor: pointer;
      user-select: none;
      font-size: 12px;
      padding: 0;
      background: linear-gradient(
        360deg,
        rgba(86, 155, 208, 0.5) 0%,
        rgba(43, 98, 163, 0.5) 100%
      );
      border-radius: 2px;
      border: 1px solid;
      border-image: linear-gradient(
          180deg,
          rgba(121, 203, 251, 1),
          rgba(163, 226, 255, 1)
        )
        1 1;

      &:focus-visible {
        outline: unset;
      }
    }
  }
}

::v-deep .mapboxgl-ctrl {
  display: none !important;
}
</style>
